export default __webpack_public_path__ + "static/media/logot.60e28d1d.svg";